import React, { useEffect, useState } from 'react';
import {
    Box, Typography, Paper, Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, CircularProgress, Alert, Breadcrumbs, Link, Chip, Button
} from '@mui/material';
import { ArrowBack, CheckCircleOutline } from '@mui/icons-material';
import { useParams, useNavigate } from 'react-router-dom';
import { getAllPartners, assignPartnerToBooking, getGroceryPartners } from '../../../services/Api';

const ViewGroceryPartners = () => {
    const { id: bookingId } = useParams();
    const navigate = useNavigate();

    const [partners, setPartners] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchPartners = async () => {
            setLoading(true);
            try {
                // Fetching large limit to filter on client side if needed, or backend might support it.
                // Assuming we want to show partners available.
                const response = await getGroceryPartners();
                if (response.success || response.data) {
                    const allPartners = response.data || [];
                    // Filter for grocery partners if partnerType exists, otherwise show all active
                    // const groceryPartners = allPartners.filter(p => !p.partnerType || p.partnerType.toLowerCase() === 'grocery');
                    setPartners(allPartners);
                } else {
                    setError(response?.message || 'Failed to fetch partners');
                }
            } catch (err) {
                setError(err.response?.data?.message || err.message || 'An error occurred while fetching partners');
                console.error(err);
            } finally {
                setLoading(false);
            }
        };

        fetchPartners();
    }, []);

    const handleAssign = async (partner) => {
        try {
            setLoading(true);
            const partnerId = partner.id || partner._id;
            const response = await assignPartnerToBooking(bookingId, { partnerId });

            if (response.success || response.message) {
                navigate('/bookings/grocery/all');
            } else {
                setError(response.message || 'Failed to assign partner');
                setLoading(false);
            }
        } catch (err) {
            console.error(err);
            setError(err.response?.data?.message || 'Error occurred while assigning partner');
            setLoading(false);
        }
    };

    return (
        <Box>
            <Box sx={{ mb: 4 }}>
                <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 1 }}>
                    <Link
                        underline="hover"
                        color="inherit"
                        href="#"
                        onClick={(e) => {
                            e.preventDefault();
                            navigate('/bookings/grocery/all');
                        }}
                        sx={{ display: 'flex', alignItems: 'center' }}
                    >
                        <ArrowBack sx={{ mr: 0.5, fontSize: 'inherit' }} />
                        Bookings
                    </Link>
                    <Typography color="text.primary">Assign Partner</Typography>
                </Breadcrumbs>
                <Typography variant="h4" sx={{ fontWeight: 300 }}>
                    Available Grocery Delivery Partners
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    Select a delivery partner to assign to booking #{bookingId}
                </Typography>
            </Box>

            {error && <Alert severity="error" sx={{ mb: 4 }}>{error}</Alert>}

            <Paper elevation={0} sx={{ border: '1px solid', borderColor: 'text.border', borderRadius: 2, overflow: 'hidden' }}>
                <TableContainer>
                    <Table sx={{ minWidth: 650 }}>
                        <TableHead sx={{ backgroundColor: 'rgba(0,0,0,0.02)' }}>
                            <TableRow>
                                <TableCell sx={{ fontWeight: 700 }}>Partner Name</TableCell>
                                <TableCell sx={{ fontWeight: 700 }}>Mobile</TableCell>
                                {/* <TableCell sx={{ fontWeight: 700 }}>Vehicle / Role</TableCell>
                                <TableCell sx={{ fontWeight: 700 }}>Status</TableCell> */}
                                <TableCell align="right" sx={{ fontWeight: 700 }}>Action</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {loading ? (
                                <TableRow>
                                    <TableCell colSpan={5} align="center" sx={{ py: 10 }}>
                                        <CircularProgress />
                                    </TableCell>
                                </TableRow>
                            ) : partners.length === 0 ? (
                                <TableRow>
                                    <TableCell colSpan={5} align="center" sx={{ py: 10 }}>
                                        <Typography color="text.secondary">No grocery partners available</Typography>
                                    </TableCell>
                                </TableRow>
                            ) : (
                                partners.map((partner) => (
                                    <TableRow key={partner.id || partner._id} hover>
                                        <TableCell sx={{ fontWeight: 600 }}>{partner.name}</TableCell>
                                        <TableCell>{partner.mobile}</TableCell>
                                        {/* <TableCell sx={{ textTransform: 'capitalize' }}>
                                            {partner.partnerType || 'Grocery'}
                                        </TableCell> */}
                                        {/* <TableCell>
                                            <Chip
                                                label={partner.isActive ? "Active" : "Inactive"}
                                                size="small"
                                                sx={{
                                                    backgroundColor: partner.isActive ? 'success.main' : 'grey.400',
                                                    color: 'white',
                                                    fontWeight: 600,
                                                }}
                                            />
                                        </TableCell> */}
                                        <TableCell align="right">
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                size="small"
                                                startIcon={<CheckCircleOutline />}
                                                onClick={() => handleAssign(partner)}
                                                // disabled={!partner.isActive}
                                                sx={{ borderRadius: '8px' }}
                                            >
                                                Assign
                                            </Button>
                                        </TableCell>
                                    </TableRow>
                                ))
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Paper>
        </Box>
    );
};

export default ViewGroceryPartners;
